/** Выбор языка — представление без стора, всё приходит пропсами. */
import { Button, WindowShell } from "../kit";
import { LOCALES, LOCALE_NAMES } from "../../../i18n";
import { type Locale } from "@newfungame/contracts";
import { useT } from "../../../app";

export interface LanguageViewProps {
  current: Locale;
  onPick(locale: Locale): void;
  onClose(): void;
}

export function LanguageView({ current, onPick, onClose }: LanguageViewProps) {
  const t = useT();
  return (
    <WindowShell kind="language" title={t("win.language.title")}>
      <div class="win-actions">
        {LOCALES.map((l) => (
          <Button tone={l === current ? "green" : "blue"} onClick={() => onPick(l)} data-testid={`language-${l}`}>
            {LOCALE_NAMES[l]}
          </Button>
        ))}
        <Button tone="link" onClick={onClose} data-testid="language-close">
          {t("win.language.close")}
        </Button>
      </div>
    </WindowShell>
  );
}
